import styled from 'styled-components';

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

export const ModalContent = styled.div`
    background: white;
    border-radius: 8px;
    padding: 32px;
    max-width: 422px;
    width: 90%;
    position: relative;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #666;
    line-height: 1;
    
    &:hover {
        color: #000;
    }
`;

export const ModalTitle = styled.h2`
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #000;
    margin-bottom: 16px;
    text-align: left;
`;

export const ModalText = styled.p`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.5;
`;

export const FieldsList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 20px 0;
`;

export const FieldItem = styled.li`
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    padding-left: 8px;
`;

export const ModalButton = styled.button`
    background-color: #1E2347;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 12px 32px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    margin-top: 16px;
    font-family: 'Roboto', sans-serif;
    
    &:hover {
        background-color: #2a3056;
    }
`;
